import { Link } from "react-router-dom";
import { useAuth, useStore } from "../../hooks";
import { useLoyalty } from "../../context";
import { formatCurrency } from "../../utilities";
import { BsTrophy } from "react-icons/bs";

const LoyaltyPointsUser = () => {
  const { isLoggedIn, isGuest, customer } = useAuth();
  const { isLoyaltyActive, loyaltyLevels } = useStore();
  const { currentLevel, loyaltyPoints, loyaltyAmount } = useLoyalty();

  if (!isLoyaltyActive || !isLoggedIn || isGuest) return <></>;

  const levelCount = loyaltyLevels.length;

  return (
    <>
      <div className="offer_reward_bann">
        <div className="welcome_user_colm">
          <div className="welcome_user_row d-flex justify-content-between align-items-center flex-wrap">
            <h5>Welome {customer?.first_name}</h5>{" "}
            <abbr>
              Level {currentLevel}/{levelCount}
            </abbr>
          </div>
          <div className="welcome_user_row1 d-flex justify-content-between align-items-center flex-wrap">
            {/* <img src={toAbsoluteUrl("images/loyalty_icon.svg")} alt="" className="l-icon" /> */}
            <h2>
              Loyalty Points <span>{loyaltyPoints} Points</span>
            </h2>
            <BsTrophy size={60} className="text-white" />
          </div>
          <h6>
            <i>User since</i> {customer?.create_ts}
          </h6>
        </div>
        <h3 className="loyalty_points">
          Loyalty Points{" "}
          <abbr>Available balance {formatCurrency(Number(loyaltyAmount))}</abbr>
          <Link to="/loyalty-points" className="know_more_btn">
            Know more
          </Link>
        </h3>
      </div>
    </>
  );
};

export default LoyaltyPointsUser;
